import { render, staticRenderFns } from "./ContractualProduct.vue?vue&type=template&id=18b85da3&scoped=true"
import script from "./ContractualProduct.vue?vue&type=script&lang=js"
export * from "./ContractualProduct.vue?vue&type=script&lang=js"
import style0 from "./ContractualProduct.vue?vue&type=style&index=0&id=18b85da3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b85da3",
  null
  
)

export default component.exports